import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
// import { BatchService } from "../batch.service";
import { ToastrService } from 'ngx-toastr';
import { EvsProductService } from '../../../../../common/services/EvsProduct.service';
import { ConfirmationService } from 'primeng/primeng';
import { ImageService } from 'app/pages/imageService';
import { AuthBusinessService } from '../../../../../common/services/AuthBusiness.service';
import { ConfigService } from './services/config.service';
import { takeUntil } from 'rxjs/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { debounce } from 'lodash';
import { Observable } from 'rxjs/Observable';
import { IOption } from 'ng-select';
import { error } from 'protractor';
import { PagerService } from '../../../../../common/services/Pagination.service';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css'],
  providers: [ConfigService],
})
export class ConfigComponent implements OnInit {

  @Output('hideCrating') hideCrating = new EventEmitter();
  @Input() detail: any = {};
  @Input() serial: any = ''; // type edit Form
  @Input() campaigns: any = [];
  @Input() list_prods: any = [];
  @ViewChild('boxRetalStamps') boxRetalStamps;
  @ViewChild('campaign') campaign: ModalDirective;

  title = 'Gán chương trình sell out';
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  addContent = '';
  listContent = [];
  unsubscribe$ = new Subject<void>();
  totalStatus;
  groupItems = [];
  waringListContent = '';
  stampList = [];
  errMess = [];
  warningMess = [];
  boxStampMess = '';
  boxStampMessWarring = '';
  public user: any;
  titleLangSub: Subscription;

  formCratingBatch: FormGroup = this.fb.group({
    is_cratingStampsSingle: [true],
    is_cratingStampsList: [false],
    stampCode: ['', [Validators.required]],
    stampCodeList: this.fb.array([]),
    note: [null],
  });
  isReadmore: Boolean = false;
  boxTypeList: Array<IOption> = [
    {
      value: '0',
      label: 'Box',
    },
    {
      value: '1',
      label: 'Planet',
    },
    {
      value: '2',
      label: 'Container',
    },
  ];


  // results$: Observable<any>
  constructor(
    private fb: FormBuilder,
    // private batchService: BatchService,
    private toastr: ToastrService,
    private configService: ConfigService,
    private imageService: ImageService,
    private pagerService: PagerService,
    private router: Router,
    public translate: TranslateService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.searchCode = debounce(this.searchCode, 1000);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.titleLangSub) {
      this.titleLangSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.title = this.translate.instant('GAN_CHUONG_TRINH_SELL_OUT') || 'Gán chương trình sell out';
    this.titleLangSub = this.translate.onLangChange.subscribe((event) => {
      this.title = event.translations['GAN_CHUONG_TRINH_SELL_OUT'] || 'Gán chương trình sell out';

      // update selectbox
      if (this.boxTypeList && this.boxTypeList.length > 0) {
        // we might need to add keys for box types if they are translatable. Currently keep as is.
      }
    });

    console.log('1111112222', this.serial)

    if (this.serial) {
      const checkSerial = this.serial.split('-->')

      if (checkSerial.length === 1) {
        this.loadDataChild(checkSerial)
        this.formCratingBatch.get('is_cratingStampsSingle').setValue(true);
        this.formCratingBatch.get('is_cratingStampsList').setValue(false);

      } else {
        this.codeList().push(this.fb.group({
          prefix: checkSerial[0].split('-')[0],
          serialFirst: checkSerial[0].split('-')[1],
          serialLast: checkSerial[1].split('-')[1],
          data: null,
          title: '',
          isReadmore: false,
        }));
        this.formCratingBatch.get('is_cratingStampsSingle').setValue(false);
        this.formCratingBatch.get('is_cratingStampsList').setValue(true);


      }
      this.checkboxSigle = false
      this.checkboxList = false
      // this.formCratingBatch.get('is_cratingStampsSingle').disable();
      // this.formCratingBatch.get('is_cratingStampsList').disable();


      let flagMyCampain = false
      let flagOtherCampain = false
      this.campaignCode = []
      this.campaigns.map((res) => {

        if (res.campaignCode) {
          this.campaignCode.push(res.campaignCode)
          this.campaignCode_old.push(res.campaignCode)
          flagOtherCampain = true;
        } else {
          flagMyCampain = true;
        }
      })
      if (flagMyCampain) {
        $('#myCampaign').click()
        this.checkSelectMyCampain = true;
        this.isCampaign = true;
        this.list_id = []
        this.listOfChecked = {}
        this.listOfChecked_old = {}
        this.campaigns.map((res) => {
          console.log('res.campaignCode', res.campaignCode)
          this.list_id.push(`${res.campaignId}#${res.campaignName}`)
          this.listOfChecked[`${res.campaignId}#${res.campaignName}`] = true
          this.listOfChecked_old[`${res.campaignId}#${res.campaignName}`] = true

        })

        this.list_id_data_old = []
        this.list_id_data = []
        this.list_id_text = []
        this.list_id.map((res) => {
          const val = res.split('#')
          this.list_id_data_old.push(val[0]);
          this.list_id_data.push(val[0]);
          this.list_id_text.push(val[1]);

        })
        console.log('this.list_id1', this.list_id);
        // console.log('this.data_stamp',this.data_campaign);
        console.log('this.listOfChecked1', this.listOfChecked);
        console.log('this.list_id_data1', this.list_id_data);
        console.log('this.list_id_text1', this.list_id_text);
      }
      if (flagOtherCampain) {
        $('#otherCampaign').click()


        this.checkSelectOtherCampain = true;

      }
    }

    console.log('campaigns', this.campaigns)
    $('#crating_type').select2({
      placeholder: '-- Hình thức đóng gói --',
      allowClear: false,
      minimumResultsForSearch: -1,
    });

    this.getListBoxType();
  }


  getListBoxType() {
    this.configService.listBoxType().subscribe(
      (res) => {
        if (res.code === 1) {
          this.boxTypeList = res.data.map((item) => {
            return {
              value: item.type,
              label: item.name,
            };
          });
        } else {
          this.boxTypeList = [];
        }
      },
      (err) => {
        this.boxTypeList = [];
        console.log(err);
      }
    );
  }

  timeout: any = null;
  checkboxSigle: boolean = true
  checkboxList: boolean = false
  firstTemp: string = ''
  lastTemp: string = ''

  changeCheckboxSigle() {
    this.checkboxSigle = $('#checkboxSigle').is(':checked')
    setTimeout(() => {
      $('#checkboxSigleVal').focus()
    }, 500)
  }

  changeCheckboxSigleValue() {

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      console.log('asdfas', $('#checkboxSigleVal').val())

      let id = '';
      if ($('#checkboxSigleVal').val().search('http') !== -1) {
        const splitLink = $('#checkboxSigleVal').val().split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = $('#checkboxSigleVal').val()
      }

      if (id) {
        console.log('id', id)

        this.configService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              this.loadDataChild([...this.listContent, ...val.data])
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning(this.translate.instant('TEM_KHONG_HOP_LE'), this.translate.instant('COMMON.CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
      $('#checkboxSigleVal').val('')

    }, 200);
  }

  changeCheckboxList() {
    this.checkboxList = $('#checkboxList').is(':checked')
    setTimeout(() => {
      $('#checkboxListF').focus()
    }, 500)
  }

  changeCheckboxListValue(type) {

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.timeout = setTimeout(() => {
      // @ts-ignore
      let checkboxListVal: any;
      if (type === 'first') {
        checkboxListVal = $('#checkboxListF')

      } else {
        checkboxListVal = $('#checkboxListL')

      }
      console.log('asdfas', checkboxListVal.val())
      // const domain = [
      //   'http://dev-qcheck.icheck.vn/',
      //   'https://dev-qcheck.icheck.vn/',
      //   'http://qcheck-dev.vn/',
      //   'https://qcheck-dev.vn/'
      // ]
      let id = '';
      if (checkboxListVal.val().search('http') !== -1) {
        const splitLink = checkboxListVal.val().split('/')
        id = splitLink[splitLink.length - 1]
        // domain.map((res) => {
        //   if (checkboxListVal.val().search(res) !== -1) {
        //     id = checkboxListVal.val().replace(res, '');
        //   }
        // })
      } else {
        id = checkboxListVal.val()
      }

      if (id) {
        console.log('id', id)

        this.configService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              if (type === 'first') {
                this.firstTemp = val.data
                $('#checkboxListL').focus()
              } else {
                // clear all
                this.lastTemp = val.data
                if (this.firstTemp.split('-')[0] === this.lastTemp.split('-')[0]) {
                  // tslint:disable-next-line:max-line-length
                  this.codeList().push(this.newCodeListScan(this.firstTemp.split('-')[0], this.firstTemp.split('-')[1], this.lastTemp.split('-')[1]));
                  this.stampCodeChanged(this.formCratingBatch.value.stampCodeList.length - 1)
                  $('#checkboxListF').val('')
                  $('#checkboxListL').val('')
                  $('#checkboxListF').focus()

                } else {
                  this.toastr.warning(this.translate.instant('SERIAL_CUOI_KHONG_HOP_LE'), this.translate.instant('COMMON.CANH_BAO'), {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                  });
                  $('#checkboxListL').val('')
                }
              }
              // this.loadDataChild([val.data])
            } else {
              this.toastr.warning(this.translate.instant('TEM_KHONG_HOP_LE'), this.translate.instant('COMMON.CANH_BAO'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning(this.translate.instant('TEM_KHONG_HOP_LE'), this.translate.instant('COMMON.CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }

    }, 200);
  }

  newCodeListScan(prefix, serialFirst, serialLast): FormGroup {
    return this.fb.group({
      prefix: prefix,
      serialFirst: serialFirst,
      serialLast: serialLast,
      data: [],
      mess: '',
    });
  }

  backToList(data = {}) {
    this.listContent = [];
    this.removeCodeListAll();
    this.formCratingBatch.get('stampCode').setValue('');
    this.hideCrating.emit(data);
  }

  changeReadMore(i, e) {
    // this.isReadmore = e;
    this.formCratingBatch.value.stampCodeList[i].isReadmore = e;
  }

  pushCampaignCode() {
    const val = $('#campaignCode').val()
    if (val) {
      // @ts-ignore
      this.campaignCode.push(val)
      $('#campaignCode').val('')
    }
    console.log('this.campaignCode', this.campaignCode)
  }

  deleteCampaign(i: any) {
    const data = []
    this.campaignCode.map((res, index) => {
      if (index !== i) {
        data.push(res)
      }
    })
    this.campaignCode = data
    console.log('this.campaignCode', this.campaignCode)
  }

  submitFormConfigConfirm(data_post: any) {
    setTimeout(() => {

      if (this.list_id_text.length === 0) {
        this.toastr.warning(this.translate.instant('BAN_CHUA_CHON_CHUONG_TRINH'), this.translate.instant('COMMON.THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      if (this.errMess.length > 0) {
        this.toastr.warning(this.translate.instant('TEM_LE_DANG_BI_LOI'), this.translate.instant('COMMON.THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      if (this.boxStampMess !== null) {
        if (this.boxStampMess.trim().length > 0) {
          this.toastr.warning(this.translate.instant('MA_TEM_THUNG_DANG_BI_LOI'), this.translate.instant('COMMON.THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          return;
        }
      }
      if (
        this.formCratingBatch.value.is_cratingStampsSingle === false &&
        this.formCratingBatch.value.is_cratingStampsList === false
      ) {
        this.toastr.warning(
          this.translate.instant('BAN_PHAI_CHON_IT_NHAT_MOT_PHUONG_THUC_DONG_THUNG'),
          this.translate.instant('COMMON.THONG_BAO'),
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          }
        );
        return;
      }
      let checkStampCodeList = 0;
      const dataStampList = [];

      data_post.stampCodeList.map((res) => {
        dataStampList.push({
          prefix: res.prefix.toUpperCase(),
          idStart: res.serialFirst,
          idEnd: res.serialLast,
        });
      });

      console.log('tuasnasdhbajsd', this.stampList);
      if (this.stampList != undefined && dataStampList.length > 0) {
        for (let i = 0; i < this.stampList.length; i++) {
          dataStampList.push(this.stampList[i]);
        }
        console.log('vao day ');
      } else {
        console.log('vào đây');
      }
      console.log('tem le ', this.stampList);
      console.log('tem dai', dataStampList);
      console.log('tem dai+ tem le', dataStampList);
      // return;
      if (checkStampCodeList > 0) {
        this.toastr.warning('Tem dải đang bị lỗi', 'Thông báo:', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      let body = {};

      if (this.listContent.length > 0 && dataStampList.length <= 0) {
        body = {
          // stamp: this.listContent,
          // box_stamp: data_post.stampCode.toUpperCase(),
          // boxType: Number(boxType),
          // note: data_post.note,
          stampGroups: this.stampList,
          campaignIds: this.checkSelectMyCampain ? this.list_id_data : [],
          campaignCodes: this.checkSelectOtherCampain ? this.campaignCode : [],
          campaignType: this.checkSelectOtherCampain && this.campaignCode.length > 0 ? 1 : 0,
          systemType: 0
        };
        // tslint:disable-next-line:max-line-length
      } else if (this.listContent.length <= 0 && dataStampList.length > 0) {
        // this.removeCodeListAll();
        body = {
          // box_stamp: data_post.stampCode.toUpperCase(),
          // boxType: Number(boxType),
          // note: data_post.note,
          stampGroups: dataStampList,
          campaignIds: this.checkSelectMyCampain ? this.list_id_data : [],
          campaignCodes: this.checkSelectOtherCampain ? this.campaignCode : [],
          campaignType: this.checkSelectOtherCampain && this.campaignCode.length > 0 ? 1 : 0,
          systemType: 0
        };
        // tslint:disable-next-line:max-line-length
      } else if (this.listContent.length <= 0 && dataStampList.length <= 0) {
        this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_TEM_LE_HOAC_DAI_TEM'), this.translate.instant('COMMON.THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      } else {
        body = {
          // stamp: this.listContent,
          // box_stamp: data_post.stampCode.toUpperCase(),
          // boxType: Number(boxType),
          // note: data_post.note
          stampGroups: dataStampList,
          campaignIds: this.checkSelectMyCampain ? this.list_id_data : [],
          campaignCodes: this.checkSelectOtherCampain ? this.campaignCode : [],
          campaignType: this.checkSelectOtherCampain && this.campaignCode.length > 0 ? 1 : 0,
          systemType: 0
        };
      }
      /**Validate khi submit */
      let errMessLoyalty = [];
      let notfi = '';
      let allItem = [];
      this.configService.validateStampSellout(body).subscribe(
        (res) => {
          if (res.code == 1) {
            allItem = res.data.items.map((val) => {
              return val;
            })
            if (allItem.length == res.data.pagination.totalElements) {
              allItem.map((val) => {
                if (val.errMessage !== null) {
                  let mess = '';
                  if (val.idStart === val.idEnd) {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase()) + ' : ' + val.errMessage;
                  } else {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase())
                      + ' -> ' + this.formatSerial(val.idEnd, val.prefix.toUpperCase())
                      + ' : ' + val.errMessage;
                  }
                  errMessLoyalty.push(mess);
                }
              });
            }
            console.log(errMessLoyalty)
            if (errMessLoyalty.length > 0) {

              this.toastr.error(errMessLoyalty.join(`<br>`), `Thông báo`, {
                timeOut: 10000,
                enableHtml: true,
                positionClass: 'toast-top-right'
              })
            } else {
              this.configService.configSellout(body).subscribe(
                (res) => {
                  if (res.code === 1) {
                    if (res.data !== null && res.data.acceptBoxed === false) {
                      this.toastr.warning(res.data.msg, 'Thông báo:', {
                        timeOut: 3000,
                        positionClass: 'toast-top-right',
                      });
                      return;
                    }
                    this.errMess = [];
                    this.warningMess = [];
                    this.boxStampMessWarring = '';
                    this.listContent = [];
                    this.campaignCode = [];
                    this.isCampaign = false;
                    this.removeCodeListAll();
                    this.formCratingBatch.get('stampCode').setValue('');
                    this.formCratingBatch.get('note').setValue('');
                    $('#crating_type').val('').trigger('change');
                    this.toastr.success('Gán chương trình sell-out thành công: ' + 'Thành công:' + res.data.success + ' Thất bại: ' + res.data.fail, 'Thông báo:', {
                      timeOut: 3000,
                      positionClass: 'toast-top-right',
                    });
                    this.backToList({ isBack: false })
                  } else {
                    this.toastr.warning(res.message, 'Thông báo:', {
                      timeOut: 3000,
                      positionClass: 'toast-top-right',
                    });
                  }
                },
                (err) => {
                  this.toastr.warning(err.message, 'Thông báo:', {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                  });
                }
              );
            }
          } else {
            console.log('vao day ko ')
            this.toastr.warning(res.message, 'Thông báo:', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
        }, (err) => {
          console.log(err);
          this.toastr.error('Có lối xảy ra', 'Thông báo:', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      );
      // this.configService.configSellout(body).subscribe(
      //   (res) => {
      //     if (res.code === 1) {
      //       if (res.data !== null && res.data.acceptBoxed === false) {
      //         this.toastr.warning(res.data.msg, "Thông báo:", {
      //           timeOut: 3000,
      //           positionClass: "toast-top-right",
      //         });
      //         return;
      //       }
      //       this.errMess = [];
      //       this.warningMess = [];
      //       this.boxStampMessWarring = "";
      //       this.listContent = [];
      //       this.campaignCode = null;
      //       this.isCampaign = false;
      //       this.removeCodeListAll();
      //       this.formCratingBatch.get("stampCode").setValue("");
      //       this.formCratingBatch.get("note").setValue("");
      //       $("#crating_type").val("").trigger("change");
      //       this.toastr.success("Gán chương trình sell-out thành công: " + "Thành công:" + res.data.success + " Thất bại: " + res.data.fail, "Thông báo:", {
      //         timeOut: 3000,
      //         positionClass: "toast-top-right",
      //       });
      //       this.backToList({ isBack: false })
      //     } else {
      //       this.toastr.warning(res.message, "Thông báo:", {
      //         timeOut: 3000,
      //         positionClass: "toast-top-right",
      //       });
      //     }
      //   },
      //   (err) => {
      //     this.toastr.warning(err.message, "Thông báo:", {
      //       timeOut: 3000,
      //       positionClass: "toast-top-right",
      //     });
      //   }
      // );
    }, 1000);
  }

  submitFormConfigConfirmUpdate(data_post: any) {
    setTimeout(() => {

      if (this.list_id_text.length === 0) {
        this.toastr.warning(this.translate.instant('BAN_CHUA_CHON_CHUONG_TRINH'), this.translate.instant('COMMON.THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      if (this.errMess.length > 0) {
        this.toastr.warning(this.translate.instant('TEM_LE_DANG_BI_LOI'), this.translate.instant('COMMON.THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      if (this.boxStampMess !== null) {
        if (this.boxStampMess.trim().length > 0) {
          this.toastr.warning(this.translate.instant('MA_TEM_THUNG_DANG_BI_LOI'), this.translate.instant('COMMON.THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          return;
        }
      }
      if (
        this.formCratingBatch.value.is_cratingStampsSingle === false &&
        this.formCratingBatch.value.is_cratingStampsList === false
      ) {
        this.toastr.warning(
          this.translate.instant('BAN_PHAI_CHON_IT_NHAT_MOT_PHUONG_THUC_DONG_THUNG'),
          this.translate.instant('COMMON.THONG_BAO'),
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          }
        );
        return;
      }
      let checkStampCodeList = 0;
      const dataStampList = [];

      data_post.stampCodeList.map((res) => {
        dataStampList.push({
          prefix: res.prefix.toUpperCase(),
          idStart: res.serialFirst,
          idEnd: res.serialLast,
        });
      });

      console.log('tuasnasdhbajsd', this.stampList);
      if (this.stampList != undefined && dataStampList.length > 0) {
        for (let i = 0; i < this.stampList.length; i++) {
          dataStampList.push(this.stampList[i]);
        }
        console.log('vao day ');
      } else {
        console.log('vào đây');
      }
      console.log('tem le ', this.stampList);
      console.log('tem dai', dataStampList);
      console.log('tem dai+ tem le', dataStampList);
      // return;
      if (checkStampCodeList > 0) {
        this.toastr.warning(this.translate.instant('TEM_DAI_DANG_BI_LOI'), this.translate.instant('COMMON.THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      let body = {};
      const list_id_data_new = [];
      this.list_id_data.map((res) => {
        if (!this.list_id_data_old.includes(res)) {
          list_id_data_new.push(res)
        }
      })
      const campaignCode_new = [];
      this.campaignCode.map((res) => {
        if (!this.campaignCode_old.includes(res)) {
          campaignCode_new.push(res)
        }
      })
      if (this.listContent.length > 0 && dataStampList.length <= 0) {
        body = {
          stampGroups: this.stampList,
          campaignIds: this.checkSelectMyCampain ? list_id_data_new : [],
          campaignCodes: this.checkSelectOtherCampain ? campaignCode_new : [],
          oldCampaignIds: this.checkSelectMyCampain ? this.list_id_data_old : [],
          oldCampaignCodes: this.checkSelectOtherCampain ? this.campaignCode_old : [],
          campaignType: 1,
          systemType: 0
        };
        // tslint:disable-next-line:max-line-length
      } else if (this.listContent.length <= 0 && dataStampList.length > 0) {
        // this.removeCodeListAll();
        body = {
          // box_stamp: data_post.stampCode.toUpperCase(),
          // boxType: Number(boxType),
          // note: data_post.note,
          stampGroups: dataStampList,
          campaignIds: this.checkSelectMyCampain ? list_id_data_new : [],
          campaignCodes: this.checkSelectOtherCampain ? campaignCode_new : [],
          oldCampaignIds: this.checkSelectMyCampain ? this.list_id_data_old : [],
          oldCampaignCodes: this.checkSelectOtherCampain ? this.campaignCode_old : [],
          campaignType: 1,
          systemType: 0
        };
        // tslint:disable-next-line:max-line-length
      } else if (this.listContent.length <= 0 && dataStampList.length <= 0) {
        this.toastr.warning(this.translate.instant('BAN_CHUA_NHAP_TEM_LE_HOAC_DAI_TEM'), this.translate.instant('COMMON.THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      } else {
        body = {
          // stamp: this.listContent,
          // box_stamp: data_post.stampCode.toUpperCase(),
          // boxType: Number(boxType),
          // note: data_post.note
          stampGroups: dataStampList,
          campaignIds: this.checkSelectMyCampain ? list_id_data_new : [],
          campaignCodes: this.checkSelectOtherCampain ? campaignCode_new : [],
          oldCampaignIds: this.checkSelectMyCampain ? this.list_id_data_old : [],
          oldCampaignCodes: this.checkSelectOtherCampain ? this.campaignCode_old : [],
          campaignType: 1,
          systemType: 0
        };
      }
      /**Validate khi submit */
      let errMessLoyalty = [];
      let notfi = '';
      let allItem = [];
      this.configService.validateStampSellout(body).subscribe(
        (res) => {
          if (res.code == 1) {
            allItem = res.data.items.map((val) => {
              return val;
            })
            if (allItem.length == res.data.pagination.totalElements) {
              allItem.map((val) => {
                if (val.errMessage !== null) {
                  let mess = '';
                  if (val.idStart === val.idEnd) {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase()) + ' : ' + val.errMessage;
                  } else {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase())
                      + ' -> ' + this.formatSerial(val.idEnd, val.prefix.toUpperCase())
                      + ' : ' + val.errMessage;
                  }
                  errMessLoyalty.push(mess);
                }
              });
            }
            console.log(errMessLoyalty)
            if (errMessLoyalty.length > 0) {

              this.toastr.error(errMessLoyalty.join(`<br>`), `Thông báo`, {
                timeOut: 10000,
                enableHtml: true,
                positionClass: 'toast-top-right'
              })
            } else {
              this.configService.configSelloutUpdate(body).subscribe(
                (res) => {
                  if (res.code === 1) {
                    if (res.data !== null && res.data.acceptBoxed === false) {
                      this.toastr.warning(res.data.msg, 'Thông báo:', {
                        timeOut: 3000,
                        positionClass: 'toast-top-right',
                      });
                      return;
                    }
                    this.errMess = [];
                    this.warningMess = [];
                    this.boxStampMessWarring = '';
                    this.listContent = [];
                    this.campaignCode = [];
                    this.isCampaign = false;
                    this.removeCodeListAll();
                    this.formCratingBatch.get('stampCode').setValue('');
                    this.formCratingBatch.get('note').setValue('');
                    $('#crating_type').val('').trigger('change');
                    this.toastr.success(this.translate.instant('THONG_DIEP_THANH_CONG') + res.data.success + ' ' + this.translate.instant('THAT_BAI') + ': ' + res.data.fail, this.translate.instant('COMMON.THONG_BAO'), {
                      timeOut: 3000,
                      positionClass: 'toast-top-right',
                    });
                    this.backToList({ isBack: false })
                  } else {
                    this.toastr.warning(res.message, this.translate.instant('COMMON.THONG_BAO'), {
                      timeOut: 3000,
                      positionClass: 'toast-top-right',
                    });
                  }
                },
                (err) => {
                  this.toastr.warning(err.message, this.translate.instant('COMMON.THONG_BAO'), {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                  });
                }
              );
            }
          } else {
            console.log('vao day ko ')
            this.toastr.warning(res.message, this.translate.instant('COMMON.THONG_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
        }, (err) => {
          console.log(err);
          this.toastr.error(this.translate.instant('COMMON.CO_LOI_XAY_RA'), this.translate.instant('COMMON.THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      );
      // this.configService.configSellout(body).subscribe(
      //   (res) => {
      //     if (res.code === 1) {
      //       if (res.data !== null && res.data.acceptBoxed === false) {
      //         this.toastr.warning(res.data.msg, "Thông báo:", {
      //           timeOut: 3000,
      //           positionClass: "toast-top-right",
      //         });
      //         return;
      //       }
      //       this.errMess = [];
      //       this.warningMess = [];
      //       this.boxStampMessWarring = "";
      //       this.listContent = [];
      //       this.campaignCode = null;
      //       this.isCampaign = false;
      //       this.removeCodeListAll();
      //       this.formCratingBatch.get("stampCode").setValue("");
      //       this.formCratingBatch.get("note").setValue("");
      //       $("#crating_type").val("").trigger("change");
      //       this.toastr.success("Gán chương trình sell-out thành công: " + "Thành công:" + res.data.success + " Thất bại: " + res.data.fail, "Thông báo:", {
      //         timeOut: 3000,
      //         positionClass: "toast-top-right",
      //       });
      //       this.backToList({ isBack: false })
      //     } else {
      //       this.toastr.warning(res.message, "Thông báo:", {
      //         timeOut: 3000,
      //         positionClass: "toast-top-right",
      //       });
      //     }
      //   },
      //   (err) => {
      //     this.toastr.warning(err.message, "Thông báo:", {
      //       timeOut: 3000,
      //       positionClass: "toast-top-right",
      //     });
      //   }
      // );
    }, 1000);
  }

  cratingStampsChange() {
    if (this.formCratingBatch.value.is_cratingStampsSingle === false) {
      this.listContent = [];
      this.checkboxSigle = false
    }
    if (this.formCratingBatch.value.is_cratingStampsList === false) {
      this.removeCodeListAll();
      this.checkboxList = false
    }
  }

  checkSelectMyCampain = true
  checkSelectOtherCampain = false

  onMyCampaign() {
    this.checkSelectMyCampain = !this.checkSelectMyCampain;
    // this.campaignCode = null;
  }

  onOtherCampaign() {
    // this.checkSelectCampain = 2;
    this.checkSelectOtherCampain = !this.checkSelectOtherCampain;
    // this.isCampaign = false
    // this.myCampaign = {}
  }

  // boxRetalStamps
  removeItem(index) {
    this.listContent = this.listContent.filter((res, i) => i !== index);
    this.stampList = this.stampList.filter((res, i) => i !== index);
    this.checkStampValidate();
  }

  showModal() {
    const data = {
      id: 'myModalCrating',
      title: this.translate.instant('THEM_DANH_SACH_TEM_LE') || 'THÊM DANH SÁCH TEM LẺ',
      contentMess: this.translate.instant('BAN_CHUA_NHAP_TEM_LE') || 'Bạn chưa nhập tem lẻ',
      listContent: this.listContent,
    };
    this.boxRetalStamps.show(data);
  }

  public stampSingle: Object;

  loadDataChild(e) {
    console.log('this.listContent', this.listContent.toString());
    const stampList = [];
    e.map((res) => {
      let splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = splitSerial[0];
        console.log(_serial, _prefix);
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }
      const stamp = {
        prefix: _prefix,
        idStart: _serial,
        idEnd: _serial,
      };
      this.stampSingle = stamp;
      stampList.push(stamp);
    });
    this.stampList = stampList;

    // this.checktemp();
    // console.log(stampList)
    this.listContent = e;
    this.checkStampValidate();
  }

  formatSerial(id: any, prefix: string) {
    let serial_f = '';
    id = id.toString();
    if (id && prefix) {
      const pad = '000000';
      const serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  checkStampValidate() {
    console.log(23434)
    this.errMess = [this.translate.instant('DANG_KIEM_TRA') || 'Đang kiểm tra...'];
    const query = {
      stampGroups: this.stampList,
      systemType: 0,
      campaignIds: [],
      campaignCodes: [],
    };
    const errMess = [];
    let allItem = [];
    if (this.listContent.length > 0) {
      this.configService.validateStampSellout(query).subscribe(
        (res) => {
          if (res.code == 1) {
            allItem = res.data.items.map((val) => {
              return val;
            })
            if (allItem.length == res.data.pagination.totalElements) {
              allItem.map((val) => {
                if (val.errMessage !== null) {
                  let mess = '';
                  if (val.idStart === val.idEnd) {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase()) + ' : ' + val.errMessage;
                  } else {
                    mess = this.formatSerial(val.idStart, val.prefix.toUpperCase())
                      + ' -> ' + this.formatSerial(val.idEnd, val.prefix.toUpperCase())
                      + ' : ' + val.errMessage;
                  }
                  errMess.push(mess);
                }
              });
            }
            console.log('mess' + errMess)
            if (errMess.length > 0) {
              this.errMess = errMess;
            } else {
              this.errMess = [];
            }
          } else {
            console.log('vao day ko ')
            this.errMess = [res.message]
          }
        }, (err) => {
          console.log(err);
          if (err && err.message) {
            this.errMess = [];
            this.errMess.push(err.message)
          } else {
            this.errMess = ['Đã có lỗi xảy ra']
          }
          this.warningMess = [];
        }
      );
    } else {
      this.errMess = [];
    }
  }

  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  codeList(): FormArray {
    return this.formCratingBatch.get('stampCodeList') as FormArray;
  }

  newCodeList(): FormGroup {
    return this.fb.group({
      prefix: '',
      serialFirst: '',
      serialLast: '',
      data: null,
      title: '',
      isReadmore: false,
    });
  }

  addCodeList() {
    // console.log(this.formCratingBatch.value);
    this.codeList().push(this.newCodeList());
  }

  removeCodeList(i: number) {
    this.codeList().removeAt(i);
    // this.checktemp();
  }

  removeCodeListAll() {
    while (this.codeList().length !== 0) {
      this.codeList().removeAt(0);
    }
  }

  stampCodeChanged(i) {
    if (
      this.formCratingBatch.value.stampCodeList[i].prefix.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialFirst.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialLast.trim() !== ''
    ) {
      this.formCratingBatch.value.stampCodeList[i].title = this.translate.instant('DANG_KIEM_TRA') || 'Đang kiểm tra...';

      // tslint:disable-next-line:radix max-line-length
      if (
        parseInt(
          this.formCratingBatch.value.stampCodeList[i].serialFirst.trim()
        ) >
        parseInt(this.formCratingBatch.value.stampCodeList[i].serialLast.trim())
      ) {
        console.log(1111);
        this.formCratingBatch.value.stampCodeList[i].title =
          this.translate.instant('SERIAL_CUOI_PHAI_LON_HON_SERIAL_DAU') || 'Serial cuối phải lớn hơn Serial đầu';
      } else {
        // this.checktemp();
        console.log('goi API', i);
        const query = {
          stampGroups: [{
            prefix: this.formCratingBatch.value.stampCodeList[i].prefix.trim().toUpperCase(),
            idStart: this.formCratingBatch.value.stampCodeList[i].serialFirst.trim(),
            idEnd: this.formCratingBatch.value.stampCodeList[i].serialLast.trim(),
          }],
          systemType: 0
          // type: 2,
          // prefix: this.formCratingBatch.value.stampCodeList[i].prefix
          //   .trim()
          //   .toUpperCase(),
          // start: this.formCratingBatch.value.stampCodeList[
          //   i
          // ].serialFirst.trim(),
          // end: this.formCratingBatch.value.stampCodeList[i].serialLast.trim(),
        };
        // @ts-ignore
        this.configService.validateStampSellout(query).subscribe(
          (res) => {
            console.log('configService', res);
            if (res.code === 1) {
              if (res.data.length === 0) {
                this.formCratingBatch.value.stampCodeList[i].data = null;
                // this.formCratingBatch.value.stampCodeList[i].warning = ''
                // this.formCratingBatch.value.stampCodeList[i].mess = ''
              } else {
                this.formCratingBatch.value.stampCodeList[i].title =
                  res.data.items[0].errMessage;
                this.formCratingBatch.value.stampCodeList[i].data = res.data.items[0];

                // if (res.data[0].acceptBoxed === false) {
                //   this.formCratingBatch.value.stampCodeList[i].mess = res.data[0].msg
                //   this.formCratingBatch.value.stampCodeList[i].warning = ''
                // } else {
                //   this.formCratingBatch.value.stampCodeList[i].warning = res.data[0].msg
                //   this.formCratingBatch.value.stampCodeList[i].mess = ''
                // }
              }
            } else {
              this.formCratingBatch.value.stampCodeList[i].title = res.message;
              this.formCratingBatch.value.stampCodeList[i].data = null;
              //
              // this.formCratingBatch.value.stampCodeList[i].mess = res.message
              // this.formCratingBatch.value.stampCodeList[i].warning = ''
            }
            console.log(this.formCratingBatch.value.stampCodeList[i]);
          },
          (err) => {
            this.formCratingBatch.value.stampCodeList[i].title =
              this.translate.instant('COMMON.CO_LOI_XAY_RA');
            // this.formCratingBatch.value.stampCodeList[i].warning = ''
          }
        );
      }
    }
  }

  checkTripNumber(item, itemFirst, itemLast) {
    // console.log(item, itemFirst, itemLast, itemFirst <= item && item <= itemLast)
    return itemFirst <= item && item <= itemLast;
  }

  // end codeList

  searchCode() {
    this.boxStampMess = this.translate.instant('DANG_KIEM_TRA') || 'Đang kiểm tra...';
    let query: any = null;
    if (
      this.formCratingBatch.value.stampCode &&
      this.formCratingBatch.value.stampCode.trim()
    ) {
      query = {
        box_stamp: this.formCratingBatch.value.stampCode.trim().toUpperCase(),
      };
    }
    // console.log(1111, query);
    if (this.formCratingBatch.value.stampCode.length > 0 && query) {
      this.configService.boxValidate(query).subscribe(
        (res) => {
          // console.log('res', res)
          if (res.code === 1) {
            if (res.data !== null && res.data.acceptBoxed === false) {
              this.boxStampMess = res.data.msg;
              this.boxStampMessWarring = '';

              return;
            }

            if (res.data !== null && res.data.acceptBoxed === true) {
              this.boxStampMessWarring = res.data.msg;
              this.boxStampMess = '';

              return;
            }
            this.boxStampMess = '';
            this.boxStampMessWarring = '';
          } else {
            this.boxStampMess = res.message;
            this.boxStampMessWarring = '';
          }
        },
        (err) => {
          this.boxStampMess =
            err && err.message ? err.message : this.translate.instant('COMMON.CO_LOI_XAY_RA');
          this.boxStampMessWarring = '';
        }
      );
    } else {
      this.boxStampMess = '';
      this.boxStampMessWarring = '';
    }
  }

  // Cấu hình chiến dịch sell-out
  campaignChange() {
    console.log(123);
  }

  data_campaign = []
  has_data_campaign: boolean = true;
  errorMessage: string = '';
  public pager: any;
  public pageIndex: number = 1;
  public page_size: number = 6;
  public totalRow: number = 0;
  public total_data_campaign: number = 0

  loadCampaign() {
    this.campaign.show();

    let query = {
      page: this.pageIndex,
      pageSize: this.page_size,
      systemType: 0
    }

    this.configService.getListCampaignSellout(query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data_campaign = res.data.pagination.totalElements;

          let list: any = [];

          for (let _data of res.data.items) {
            let obj = {
              id: _data.id,
              name: _data.name,
              image: this.imageService.readSrcImage(_data.image, 'thumb_large'),
              status: _data.status,
              idEnd: _data.idEnd,
              statusTitle: _data.statusTitle,
              start: _data.start,
              end: _data.end,
              approved: _data.approved,

            };
            list.push(obj);
          }
          ;

          this.data_campaign = list

          console.log(this.has_data_campaign);

          if (list.length > 0) {
            this.has_data_campaign = true;
          } else {
            this.has_data_campaign = false;
          }
        } else {
          this.errorMessage = res.message;
        }
        (err) => {
          console.log(err)
        }
      }
    )
  }

  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      // this.loading_left = true;
      this.loadCampaign();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )
    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    // this.loading_left = true;
    this.loadCampaign();
    // }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      // this.loading_left = true;
      this.loadCampaign();
    }
  }

  listOfChecked = {};
  listOfChecked_old = {};
  list_id = [];
  list_id_data = [];
  list_id_data_old = [];
  list_id_text = [];
  checkSelectCampain: number = 0;
  myCampaign = {}
  isCampaign = false;
  campaignCode = [];
  campaignCode_old = [];

  onchange() {
    console.log('checkbox');
  }


  radioBoxChange(event) {
    this.listOfChecked = event.target.value;
    console.log('tuanba: ' + this.listOfChecked);
  }

  confirmCampaign() {
    if (this.list_id.length == 0) {
      this.toastr.error(this.translate.instant('COMMON.BAN_CHUA_CHON_DIEM_BAN'), '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return
    }
    // this.myCampaign = this.listOfChecked.split(',');
    this.isCampaign = true;
    this.campaign.hide();
    this.pageIndex = 1;
    // this.list_id.map((res) => {
    //   const val = res.split('#')
    //   this.list_id_data.push(val[0]);
    //   this.list_id_text.push(val[1]);
    //
    // })
    console.log('this.list_id', this.list_id);
    // console.log('this.data_stamp',this.data_campaign);
    console.log('this.listOfChecked', this.listOfChecked);
  }

  isCheckAll = false;

  // data_stamp = [];

  checkALl(event) {
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.data_campaign.map((item) => {
        this.listOfChecked[item.id + '#' + item.name] = true;
      });
      this.listIdChecked();
      return;
    }
    this.data_campaign.map((item) => {
      this.listOfChecked[item.id + '#' + item.name] = false;
      this.listIdChecked();
    });
  }

  listIdChecked() {
    for (const key in this.listOfChecked) {
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
    this.list_id_data = []
    this.list_id_text = []
    this.list_id.map((res) => {
      const val = res.split('#')
      this.list_id_data.push(val[0]);
      this.list_id_text.push(val[1]);

    })
    console.log('this.list_id', this.list_id)
  }

  checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;
    this.listOfChecked[value] = checked;
    this.isCheckAll = this.data_campaign.every(
      (item) => this.listOfChecked[item.id + '#' + item.name]
    );

    this.listIdChecked();
  }

  deleteCheckbox(i: any) {
    const value = this.list_id_data[i] + '#' + this.list_id_text[i]
    this.listOfChecked[value] = false;
    this.isCheckAll = this.data_campaign.every(
      (item) => this.listOfChecked[item.id + '#' + item.name]
    );
    this.listIdChecked();
  }

  refeshCheckAll() {
    if (this.data_campaign && this.data_campaign.length) {
      this.isCheckAll = this.data_campaign.every(
        (item) => this.listOfChecked[item.id + '#' + item.name]
      );
      return;
    }
    this.isCheckAll = false;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-sellout/config/config.component.ts